import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'

// Função para disparar evento de conversão do Google Ads
const trackConversion = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-17420851514/zxaUCIrdxv0aELqy9PJA',
      'value': 1.0,
      'currency': 'USD'
    });
    console.log('Conversão do Google Ads rastreada');
  } else {
    console.warn('Google Ads (gtag) não está disponível ainda');
  }
}

// API do Gatsby para executar código quando a aplicação carrega
export const onClientEntry = () => {
  // Disponibilizar a função globalmente
  if (typeof window !== 'undefined') {
    window.trackConversion = trackConversion;
    
    // Aguardar o gtag carregar
    const checkGtag = () => {
      if (window.gtag) {
        console.log('Google Ads (gtag) carregado com sucesso');
      } else {
        setTimeout(checkGtag, 500);
      }
    };
    checkGtag();
  }
}